import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

const Login = lazy(() => import('./pages/Login'));
const Signup = lazy(() => import('./pages/Signup'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Pricing = lazy(() => import('./pages/Pricing'));
const PaymentSetup = lazy(() => import('./pages/PaymentSetup'));
const BillingHistory = lazy(() => import('./pages/BillingHistory'));
const UpgradePlan = lazy(() => import('./pages/UpgradePlan'));
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const TermsPublic = lazy(() => import('./pages/TermsPublic'));
const PrivacyPublic = lazy(() => import('./pages/PrivacyPublic'));

const PageLoader = () => (
  <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',background:'var(--light-bg)'}}>
    <div style={{textAlign:'center'}}>
      <div className="spinner" style={{margin:'0 auto 16px'}}></div>
      <p style={{color:'#64748b',fontSize:'14px'}}>Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terms" element={<TermsPublic />} />
            <Route path="/privacy" element={<PrivacyPublic />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscription/payment"
              element={
                <PrivateRoute>
                  <PaymentSetup />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscription/invoices"
              element={
                <PrivateRoute>
                  <BillingHistory />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscription/upgrade"
              element={
                <PrivateRoute>
                  <UpgradePlan />
                </PrivateRoute>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
}

export default App;
